<ng-template #voorwaardenOrb>
    <!-- prettier-ignore -->
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsLegalInsurance"
                      pdfLinkTitle="Voorwaarden Rechtsbijstandverzekering">in onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>

<ng-template #voorwaardenAvp>
    <!-- prettier-ignore -->
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsLiabilityInsurance"
                      pdfLinkTitle="Voorwaarden Aansprakelijkheidsverzekering">in onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>

<ng-template #voorwaardenOngeval>
    <!-- prettier-ignore -->
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat 
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsAccidentInsurance" pdfLinkTitle="Voorwaarden Ongevallenverzekering">in onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>

<ng-container *ngIf="coverageId === coverageIdEnum.RechtshulpOngeval">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
            <div>
                <p>
                    U en uw gezinsleden zijn wereldwijd verzekerd voor juridische hulp bij:
                </p>
                <wuc-list icon="check">
                    <wuc-list-item>
                        Conflicten over een ongeluk in het verkeer (met de auto, maar bijvoorbeeld ook met de brommer,
                        motor, fiets of boot) of bij een ongeval als u passagier bent van een vliegtuig of in het openbaar vervoer
                    </wuc-list-item>
                    <wuc-list-item>
                        Geschillen omdat u betrokken bent bij een ongeluk (binnen en buiten het verkeer, ook als u te voet bent)
                    </wuc-list-item>
                    <wuc-list-item>
                        Overheidsmaatregelen in de hierboven genoemde situaties (strafvervolging, inbeslagname van uw rijbewijs,
                        auto, brommer, scooter of motor)
                    </wuc-list-item>
                    <wuc-list-item>
                        Het oplopen van lichamelijke- of psychische schade door een medische fout
                    </wuc-list-item>
                </wuc-list>
                <br>
                <h3>Verzekerde bedragen:</h3>
                <p>
                    De kosten van de juristen en advocaten van LegalShared en hun netwerk zijn onbeperkt verzekerd. Dit geldt ook
                    voor de juridisch deskundigen die zij inschakelen. Voor de overige kosten gelden wel maximumbedragen.
                </p>
            </div>
                <ng-container *ngTemplateOutlet="voorwaardenOrb"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>
                        U krijgt geen juridische hulp als:
                    </p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Het conflict te maken heeft met verhuur, koop of verkoop</wuc-list-item>
                        <wuc-list-item>U mensen of spullen bedrijfsmatig vervoert</wuc-list-item>
                        <wuc-list-item>U bedrijfsmatig rijles geeft of examens afneemt</wuc-list-item>
                        <wuc-list-item>U meedoet aan een wedstrijd. Bijvoorbeeld een snelheidsrit, behendigheidswedstrijd of een wedstrijd driften</wuc-list-item>
                        <wuc-list-item>U niet mocht rijden, varen of vliegen omdat u alcohol, drugs of medicijnen gebruikte</wuc-list-item>
                        <wuc-list-item>U ons niet alles of niet de waarheid vertelt of als u niet meewerkt</wuc-list-item>
                        <wuc-list-item>U iets doet wat nadelig is voor onze Rechtshulporganisaties zoals het conflict te laat melden, waardoor de behandeling duurder en moeilijker wordt</wuc-list-item>
                        <wuc-list-item>U de strafzaak of boete ook administratief kunt afhandelen (zoals het betalen van een boete)</wuc-list-item>
                        <wuc-list-item>
                            U niet voldoet aan onze
                            <wuc-link [url]="documentsEnum.ConditionsGeneral" title="Algemene Voorwaarden">algemene</wuc-link>
                            of
                            <wuc-link [url]="documentsEnum.ConditionsLegalInsurance" title="Voorwaarden Rechtsbijstandverzekering">bijzondere</wuc-link>
                            voorwaarden
                        </wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        Als u ervan beschuldigd wordt dat u met opzet de wet overtreden heeft, krijgt u geen juridische
                        hulp bij overheidsmaatregelen (zoals het invorderen van uw rijbewijs of voertuig).
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenOrb"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Meteen verzekerd?">
            <p>
                Voor deze dekking geldt geen wachttijd. Dat betekent dat u verzekerd bent voor conflicten die ontstaan
                nadat uw verzekering is ingegaan.
            </p>
            <ng-container *ngTemplateOutlet="voorwaardenOrb"></ng-container>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <p>Uw eigen risico is: €&nbsp;0.</p>
            <p>
                1 uitzondering: als u een eigen advocaat (die dus niet werkzaam is voor de Rechtshulporganisatie) inschakelt bij
                een gerechtelijke of administratieve procedure, is uw eigen risico €&nbsp;250.
            </p>
            <ng-container *ngTemplateOutlet="voorwaardenOrb"></ng-container>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.Aansprakelijkheidsverzekering">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Schade die u of uw gezinsleden en huisdieren als particulier veroorzaken aan:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Spullen, dingen of personen buiten uw gezin</wuc-list-item>
                        <wuc-list-item>Personen binnen uw gezin (letsel)</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>InShared verzekert ook spullen die u of een gezinslid stukmaakt of letsel aan anderen:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Tijdens het rijden op een fiets of brommer</wuc-list-item>
                        <wuc-list-item>Tijdens stage/vrijwilligerwerk</wuc-list-item>
                        <wuc-list-item>Als uw kinderen spelen</wuc-list-item>
                        <wuc-list-item>Brand of waterschade aan een gehuurd vakantieverblijf</wuc-list-item>
                        <wuc-list-item>Door joyriding</wuc-list-item>
                        <wuc-list-item>Terwijl u de spullen te leen had</wuc-list-item>
                        <wuc-list-item>Tijdens een vriendendienst</wuc-list-item>
                        <wuc-list-item>Bij letsel aan anderen tijdens sport en spel</wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenAvp"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Schade:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Ontstaan tijdens uw werk</wuc-list-item>
                        <wuc-list-item>Aan spullen die u huurt/least/pacht/in vruchtgebruik heeft</wuc-list-item>
                        <wuc-list-item>
                            Door motorrijtuigen of (lucht)vaartuigen, als daar een rij- of vaarbewijs voor nodig is
                        </wuc-list-item>
                        <wuc-list-item>Door (heli)drones/ of grotere modelvliegtuigjes</wuc-list-item>
                        <wuc-list-item>Aan werkspullen die u privé gebruikt (laptop)</wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenAvp"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <p>Uw eigen risico is: €&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaardenAvp"></ng-container>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.OngevalBlijvendLetsel">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>
                        U krijgt een van tevoren vastgesteld bedrag als u blijvend invalide raakt als gevolg van een ongeval. Of
                        u heeft recht op een vergoeding van kosten als door een ongeval medische- of tandheelkundige hulp
                        noodzakelijk is.
                    </p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Ongevallen bij u thuis, buiten uw huis en in het verkeer</wuc-list-item>
                        <wuc-list-item>Ongevallen in binnen- en buitenland</wuc-list-item>
                        <wuc-list-item>Uw gezinsleden, als u die meeverzekerd heeft (met de opgegeven
                            gezinssamenstelling)</wuc-list-item>
                        <wuc-list-item>In- en opzittenden van uw auto, fiets, motor en brommer</wuc-list-item>
                        <wuc-list-item>Een vergoeding voor tandheelkundige hulp en geneeskundige kosten door een
                            ongeval</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>Een ongeval is ook:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Vergiftiging</wuc-list-item>
                        <wuc-list-item>Besmetting doordat u ongewild in water valt</wuc-list-item>
                        <wuc-list-item>Letsel doordat u ongewild en plotseling stoffen of voorwerpen
                            binnenkrijgt</wuc-list-item>
                        <wuc-list-item>Plotseling scheuren of ontwrichten van een spier, band of pees</wuc-list-item>
                        <wuc-list-item>Bevriezing, verbranding, verdrinking, verstikking, zonnesteek,
                            hitteberoerte</wuc-list-item>
                        <wuc-list-item>Uitputting, verhongering, uitdroging of zonnebrand omdat u geïsoleerd raakt, zoals bij
                            een schipbreuk of natuurramp</wuc-list-item>
                        <wuc-list-item>Wondinfectie en bloedvergiftiging als gevolg van een ongeval</wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenOngeval"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>
                        Blijvende invaliditeit, medische- of tandheelkundige hulp bij een ongeval is niet verzekerd bij:
                    </p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Opzet</wuc-list-item>
                        <wuc-list-item>Strafbare activiteiten</wuc-list-item>
                        <wuc-list-item>Gebruik van drugs, alcohol of medicijnen</wuc-list-item>
                        <wuc-list-item>Deelname aan militaire activiteiten</wuc-list-item>
                        <wuc-list-item>Snelheids- en behendigheidswedstrijden of slipcursussen</wuc-list-item>
                        <wuc-list-item>Gevaarlijke sporten als vechtsporten, parachutespringen of deltavliegen</wuc-list-item>
                        <wuc-list-item>Sportbeoefening tegen betaling</wuc-list-item>
                        <wuc-list-item>Deelname aan wedstrijden voor bepaalde sporten zoals wielrennen of wintersport</wuc-list-item>
                        <wuc-list-item>Zelfmoord (of poging daartoe)</wuc-list-item>
                        <wuc-list-item>Rijden met een motorrijtuig zonder geldig rijbewijs</wuc-list-item>
                        <wuc-list-item>Rijden op een bromfiets die is opgevoerd</wuc-list-item>
                        <wuc-list-item>Een beet of steek van een insect</wuc-list-item>
                        <wuc-list-item>Deelname aan onlusten, relletjes, sabotage of terreur</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>We vergoeden ook niet als:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>De verzekerde ouder dan 80 jaar is</wuc-list-item>
                        <wuc-list-item>Tandheelkundige hulp en medische kosten ergens anders geclaimd kunnen worden. Denk bijvoorbeeld aan een zorgpolis of reisverzekering.</wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenOngeval"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Verzekerde bedragen">
            <wuc-rack gridGap="medium">
                <wuc-list icon="dot">
                    <wuc-list-item>
                        Maximaal €&nbsp;60.000 bij blijvende invaliditeit per verzekerd persoon. U, een verzekerd gezinslid,
                        inzittenden van uw auto of opzittenden van uw brommer of motor krijgen een bedrag afhankelijk van de
                        mate van invaliditeit. Bijvoorbeeld:
                        <wuc-list icon="dot">
                            <wuc-list-item>
                                U verliest bij een ongeval een duim, uitkering 25% van €&nbsp;60.000
                            </wuc-list-item>
                            <wuc-list-item>
                                U verliest bij een ongeval een voet, uitkering 40% van €&nbsp;60.000
                            </wuc-list-item>
                        </wuc-list>
                    </wuc-list-item>
                    <wuc-list-item>
                        Maximaal €&nbsp;2.500 per verzekerd persoon voor medische en/of tandheelkundige hulp
                    </wuc-list-item>
                </wuc-list>
                <ng-container *ngTemplateOutlet="voorwaardenOngeval"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <p class="no-brake">€&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaardenOngeval"></ng-container>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.OngevalOverlijden">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Achterblijvers hebben na een ongeval met dodelijke afloop al genoeg aan hun hoofd. Met de ongeval &
                        overlijden verzekering, verzekert u hen tegen de financiële zorgen met een uitkering van €&nbsp;15.000.</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Ongevallen bij u thuis, buiten uw huis en in het verkeer</wuc-list-item>
                        <wuc-list-item>Ongevallen in binnen- en buitenland</wuc-list-item>
                        <wuc-list-item>Uw gezinsleden, als u die meeverzekerd heeft (met de opgegeven
                            gezinssamenstelling)</wuc-list-item>
                        <wuc-list-item>In- en opzittenden van uw auto, fiets, motor en brommer</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>Een ongeval is ook:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Vergiftiging</wuc-list-item>
                        <wuc-list-item>Besmetting doordat u ongewild in water valt</wuc-list-item>
                        <wuc-list-item>Letsel doordat u ongewild en plotseling stoffen of voorwerpen
                            binnenkrijgt</wuc-list-item>
                        <wuc-list-item>Plotseling scheuren of ontwrichten van een spier, band of pees</wuc-list-item>
                        <wuc-list-item>Bevriezing, verbranding, verdrinking, verstikking, zonnesteek,
                            hitteberoerte</wuc-list-item>
                        <wuc-list-item>Uitputting, verhongering, uitdroging of zonnebrand omdat u geïsoleerd raakt, zoals bij
                            een schipbreuk of natuurramp</wuc-list-item>
                        <wuc-list-item>Wondinfectie en bloedvergiftiging als gevolg van een ongeval</wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenOngeval"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Overlijden na een ongeval ontstaan door of onder invloed van:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Opzet</wuc-list-item>
                        <wuc-list-item>Strafbare activiteiten</wuc-list-item>
                        <wuc-list-item>Gebruik van drugs, alcohol of medicijnen</wuc-list-item>
                        <wuc-list-item>Deelname aan militaire activiteiten</wuc-list-item>
                        <wuc-list-item>Snelheids- en behendigheidswedstrijden of slipcursussen</wuc-list-item>
                        <wuc-list-item>Gevaarlijke sporten als vechtsporten, parachutespringen of deltavliegen</wuc-list-item>
                        <wuc-list-item>Sportbeoefening tegen betaling</wuc-list-item>
                        <wuc-list-item>Deelname aan wedstrijden voor bepaalde sporten zoals wielrennen of
                            wintersport</wuc-list-item>
                        <wuc-list-item>Zelfmoord (of poging daartoe)</wuc-list-item>
                        <wuc-list-item>Rijden met een motorrijtuig zonder geldig rijbewijs</wuc-list-item>
                        <wuc-list-item>Rijden op een bromfiets die is opgevoerd</wuc-list-item>
                        <wuc-list-item>Een beet of steek van een insect</wuc-list-item>
                        <wuc-list-item>Deelname aan onlusten, relletjes, sabotage of terreur</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>We vergoeden ook niet als:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>De verzekerde ouder dan 80 jaar is</wuc-list-item>
                        <wuc-list-item>Tandheelkundige hulp en medische kosten ergens anders geclaimd kunnen worden. Denk
                            bijvoorbeeld aan een zorgpolis of reisverzekering.</wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenOngeval"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Verzekerde bedragen">
            <p>€&nbsp;15.000 per inzittende bij overlijden</p>
            <ng-container *ngTemplateOutlet="voorwaardenOngeval"></ng-container>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <p class="no-brake">€&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaardenOngeval"></ng-container>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>
